import React, {
  PureComponent
} from 'react';
import ModalForm from './forms/modalForm';
import PropTypes from "prop-types";

class Demo extends PureComponent {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      tabParam: {}
    }
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  init() {
    this.title = 'Form示例';
    this.subTitle = '纵向示例表单';
    this.setState({
      tabParam: window.LayoutTab['tabParam']
    });
    this.context.store.subscribe(() => {
      this.state.tabParam = window.LayoutTab['tabParam'];
      this.state.tabParam && this.setState({
        tabParam: JSON.parse(JSON.stringify(this.state.tabParam))
      });
    });
  }

  componentWillMount() {
    this.init();
  }

  render() {
    return <div>
      <ModalForm layout={1} param={this.state.tabParam}></ModalForm>
    </div>;
  }
}

export default Demo;

Demo.propTypes = {
  addTab: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/AntD/pages/example/demo_2/demo.js